<template>
	<div class="front-rule-tree">
		<div class="front-rule-tree__bar">
			<el-checkbox v-model="checkAll" @change="onCheckAll">全选</el-checkbox>
			<el-button type="text" @click="toggleExpand">{{ expanded ? '收起' : '展开' }}</el-button>
		</div>
		<el-tree
			ref="tree"
			:data="treeData"
			show-checkbox
			node-key="id"
			:default-expand-all="expanded"
			:props="{ label: 'label', children: 'children' }"
			@check="emitValue" />
	</div>
</template>

<script>
export default {
	name: 'FrontRuleTree',
	props: {
		nodes: { type: Array, default: () => [] },
		value: { type: String, default: '' },
	},
	data() {
		return {
			checkAll: false,
			expanded: true,
		};
	},
	computed: {
		treeData() {
			return buildTree(this.nodes);
		},
	},
	watch: {
		value() {
			this.syncChecked();
		},
		nodes() {
			this.$nextTick(() => this.syncChecked());
		},
	},
	mounted() {
		this.syncChecked();
	},
	methods: {
		syncChecked() {
			if (!this.$refs.tree) return;
			if (String(this.value || '').trim() === '*') {
				this.checkAll = true;
				this.$refs.tree.setCheckedNodes(this.treeData);
				return;
			}
			const keys = String(this.value || '')
				.split(',')
				.map((s) => s.trim())
				.filter(Boolean);
			this.$refs.tree.setCheckedKeys(keys);
			this.checkAll = false;
		},
		onCheckAll(val) {
			if (!this.$refs.tree) return;
			if (val) {
				this.$refs.tree.setCheckedNodes(this.treeData);
				this.$emit('input', '*');
			} else {
				this.$refs.tree.setCheckedKeys([]);
				this.$emit('input', '');
			}
		},
		toggleExpand() {
			this.expanded = !this.expanded;
		},
		emitValue() {
			if (!this.$refs.tree) return;
			const keys = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
			this.checkAll = false;
			this.$emit('input', keys.join(','));
		},
	},
};

function buildTree(nodes) {
	const list = Array.isArray(nodes) ? nodes : [];
	const map = {};
	const roots = [];
	list.forEach((n) => {
		const id = String(n.id ?? '');
		if (!id) return;
		map[id] = { id, label: n.text || n.label || n.title || id, children: [] };
	});
	list.forEach((n) => {
		const id = String(n.id ?? '');
		const parent = n.parent && n.parent !== '#' ? String(n.parent) : String(n.pid || 0);
		if (!map[id]) return;
		if (parent && parent !== '0' && map[parent]) map[parent].children.push(map[id]);
		else roots.push(map[id]);
	});
	return roots;
}
</script>

<style scoped>
.front-rule-tree {
	max-height: 320px;
	overflow: auto;
	border: 1px solid var(--app-border, #e5e7eb);
	border-radius: 8px;
	padding: 8px 10px;
}
.front-rule-tree__bar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 6px;
}
</style>
